import React, { useState } from "react";
import {
  TextInput,
  PasswordInput,
  Text,
  Button,
  Alert,
  Stack,
  Title,
} from "@mantine/core";
import { IconAlertCircle } from "@tabler/icons-react";
import useAuthStore from "../../store/useAuthStore";
import "../styles/main.css";

const SignIn = () => {
  const login = useAuthStore((state) => state.login);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    try {
      await login(email, password);
    } catch (err) {
      console.error("Login failed", err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-split-container">
      <div className="login-brand"><img src="/logo.svg" alt="Profit Junkies" /><span>Utility <span style={{ color: "#aaa8b1", fontWeight: 400 }}>/ Profit Junkies</span></span></div>
      <div className="login-right-pane">
        <div className="login-intro">
          <Title order={2} mb={8}>Sign in to your workspace</Title>
          <Text c="dimmed">Your tools, performance and team. In one place.</Text>
        </div>
        <div className="login-form">
          {error && <Alert variant="light" color="red" icon={<IconAlertCircle size={16} />} mb="md">{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput label="Username / Login" placeholder="Enter your username" required value={email} onChange={(e) => setEmail(e.currentTarget.value)} />
              <PasswordInput label="Password" placeholder="Enter your password" required value={password} onChange={(e) => setPassword(e.currentTarget.value)} />
              <Button fullWidth mt={4} type="submit" loading={isLoading}>Sign in</Button>
            </Stack>
          </form>
        </div>
      </div>
      <div className="login-footer">Profit Junkies Operations · 2026</div>
    </div>
  );
};

export default SignIn;
